import { FieldInfoGroupField, HiddenField } from '@app/common/configurable-wizards';
import { isDefined } from '@app/common/utils';

export type MappedSubFields = Record<string, Record<string, any>>;

export const isPrimaryField = (fld: any): boolean => (
  fld?.id === 'IsPrimary'
  && (fld?.sValue === 'true' || fld?.sValue === true));

export const getPrimary = (fld: FieldInfoGroupField):HiddenField => (
  fld.subFields.find(isPrimaryField) as HiddenField);

export const isPrimaryFieldGroup = (fld: any): boolean => (
  isDefined(getPrimary(fld as FieldInfoGroupField)));

export const arrangeByPrimary = (field:FieldInfoGroupField) => {
  const primaryFldGroup = field.subFields.find(isPrimaryFieldGroup);

  return primaryFldGroup
    ? [
      primaryFldGroup,
      ...field.subFields.filter((item:any) => item !== primaryFldGroup),
    ]
    : field.subFields;
};
